import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeChecker } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentOrganizationAssignment on OrganizationAssignment {
    id
    isOccupier
    organizationLookup
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentOrganizationAssignmentFragment,
  ents.extra.space.Record.OrganizationAssignment
>({
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.extra.space.Record.OrganizationAssignment.Id.isId,
  ),
  isOccupier: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeChecker.isBoolean,
  ),
  organizationLookup: graphql.transformers.OUT.validate(
    graphql.transformers.OUT.json(),
    ents.extra.space.Organization.Lookup.assertIsLookup,
  ),
})
